import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth, arrowWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_RED } from "../../../config/constants";

const Track16ARed = ({ state, workState, onLabelClick }) => (
	<g id="Track16ARed" transform="translate(2318.000000, 390.000000)" className="track">
		<g id="line" transform="translate(0.000000, 0.738544)"
			 stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)} strokeLinecap="round"
			 strokeWidth={tracksWidth}
		>
			<path
				d="M66.5,23.7614564 L109.674047,12.3476293 C135.584501,5.49774019 162.196985,20.7088573 169.444258,46.5109818 L169.444258,46.5109818 L169.444258,46.5109818 L170.321977,49.2614564"/>

			<path
				d="M173.345323,60.39976 L173.888728,62.334421 C178.713481,79.5117611 188.046138,95.0854396 200.918671,107.44008 L213.34349,119.365018 C220.394075,126.131941 226.414664,133.895819 231.213267,142.409068 L261.625503,196.363726 C270.789195,212.621123 268.420261,232.933478 255.761341,246.645807 L234.942444,269.197146 C222.342339,282.845767 205.493384,291.827607 187.138327,294.680563 L187.138327,294.680563 L187.138327,294.680563"/>

			
			<polyline id="arrow" strokeWidth={arrowWidth} strokeLinejoin="round"
								transform="translate(169.485255, 47.063578) rotate(-108.000000) translate(-169.485255, -47.063578) "
								points="173.485255 55.063578 165.485255 47.063578 173.485255 39.063578"/>
		</g>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'Track16ARed')}
			coords="217.257812, 137.808768"
			text="16A"
			textCoordsX="6.71484375"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
		/>
	</g>

);

Track16ARed.propTypes = trackPropTypes;

export default Track16ARed;
